import { render, staticRenderFns } from "./ApprovalConfigurationContent.vue?vue&type=template&id=ef549c7a&scoped=true&"
import script from "./ApprovalConfigurationContent.vue?vue&type=script&lang=js&"
export * from "./ApprovalConfigurationContent.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalConfigurationContent.vue?vue&type=style&index=0&id=ef549c7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef549c7a",
  null
  
)

export default component.exports